import { render } from "./WarehouseList.vue?vue&type=template&id=2df05f60&scoped=true"
import script from "./WarehouseList.vue?vue&type=script&lang=js"
export * from "./WarehouseList.vue?vue&type=script&lang=js"

import "./WarehouseList.vue?vue&type=style&index=0&id=2df05f60&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df05f60"],['__file',"src/views/h5/common/stock/warehouse/WarehouseList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2df05f60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2df05f60', __exports__)) {
    api.reload('2df05f60', __exports__)
  }
  
  module.hot.accept("./WarehouseList.vue?vue&type=template&id=2df05f60&scoped=true", () => {
    api.rerender('2df05f60', render)
  })

}


export default __exports__